import React, { Component } from "react";

import {
  resetScrollPosition,
  removeNavBar,
  activeNavBar,
} from "../../../services/actions/scroll.actions";
import { activateAnimSlide } from "../../../services/actions/animation.actions";
import InformUserCart from "../../../components/user/InformUserCart";
import { formatNumber, isDesktop } from "../../../utils/utils";
import Fade from "@material-ui/core/Fade";
import { connect } from "react-redux";
import Router from "next/router";

import dynamic from "next/dynamic";
const DynamicCategoryList = dynamic(
  import("../../../containers/Menu/components/CategoryList"),
  { ssr: false }
);
const DynamicCart = dynamic(import("../../../containers/Cart"), { ssr: false });

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenDesktop: null,
      activeNav: false,
      positionNav: 0,
      firstTimeScroll: true,
    };
    this.setPositionScroll = this.setPositionScroll.bind(this);
    this.setPositionNav = this.setPositionNav.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.redirectCart = this.redirectCart.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.scrollPosition &&
      nextProps.scrollPosition !== this.props.scrollPosition
    ) {
      if (!this.state.screenDesktop) {
        window.scrollTo(0, 0);
      }
      this.setPositionScroll(nextProps.scrollPosition, 500);
    }
  }

  componentDidMount() {
    const screenDesktop = isDesktop(window);
    this.setState({ screenDesktop }, () => {
      window.addEventListener("scroll", this.handleScroll);
    });
  }

  componentWillUnmount() {
    if (!this.state.screenDesktop) {
      this.props.activateAnimSlide();
    }
    window.removeEventListener("scroll", this.handleScroll),
      this.props.removeNavBar();
  }

  setPositionScroll(position, timeout = 0) {
    if (window) {
      window.setTimeout(() => {
        document.getElementById(position).scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, timeout);
    }
    window.setTimeout(() => {
      this.props.resetScrollPosition();
    }, timeout + 2000);
  }

  setPositionNav(position) {
    const { positionNav } = this.state;
    if (!positionNav) {
      this.setState({ positionNav: position });
    }
  }

  handleScroll() {
    const { screenDesktop, firstTimeScroll } = this.state;
    if (!firstTimeScroll) {
      let navBar = document.getElementsByClassName(
        "container-name-categories"
      )[0];
      let mobileNavContainer = !screenDesktop
        ? document.getElementsByClassName("container-mobile-title-link-nav")[0]
        : null;
      let mobileNavScroll = !screenDesktop
        ? document.getElementsByClassName("override-flexContainer")[0]
        : null;
      let sticky = navBar.offsetTop;
      this.setPositionNav(sticky);
      if (
        window.pageYOffset >= this.state.positionNav &&
        !this.state.activeNav
      ) {
        this.setState({ activeNav: true }, () => {
          if (!screenDesktop) {
            mobileNavContainer.classList.remove("blur");
            mobileNavScroll.classList.add("blur");
          }
          navBar.classList.add("sticky");
          this.props.activeNavBar();
        });
      }
      if (window.pageYOffset < this.state.positionNav && this.state.activeNav) {
        this.setState({ activeNav: false }, () => {
          if (!screenDesktop) {
            mobileNavContainer.classList.add("blur");
            mobileNavScroll.classList.remove("blur");
          }
          navBar.classList.remove("sticky");
          this.props.removeNavBar();
        });
      }
    }
    this.setState({ firstTimeScroll: false });
  }

  redirectCart() {
    Router.push(
      "/commande-en-ligne/[idRestaurant]/panier",
      `/commande-en-ligne/${Router.query.idRestaurant}/panier`
    );
  }

  render() {
    const { valueCart, idRestaurant, currency } = this.props;
    const valueCartFormate = formatNumber(valueCart);
    const { screenDesktop, activeNav } = this.state;
    return (
      <Fade in={true} mountOnEnter unmountOnExit timeout={500}>
        <div id="restaurant-menu">
          <DynamicCategoryList />
          {screenDesktop ? (
            <div className="super-container-card">
              <DynamicCart idRestaurant={idRestaurant} activeNav={activeNav} />
            </div>
          ) : valueCart ? (
            <InformUserCart
              redirectCart={this.redirectCart}
              totalPrice={valueCartFormate}
              currency={currency}
            />
          ) : (
            ""
          )}
        </div>
      </Fade>
    );
  }
}

const mapStateToProps = (state) => {
  const { restaurant, scroll, cart } = state;
  return {
    currency: restaurant.infoRestaurant.currency,
    scrollPosition: scroll.position,
    valueCart: cart.valueBasket,
  };
};

const actionCreators = {
  resetScrollPosition,
  activateAnimSlide,
  removeNavBar,
  activeNavBar,
};

export default connect(mapStateToProps, actionCreators)(Menu);
